import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { FaWindowClose, FaCheck, FaTimes, FaInbox } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import { DESCRICOES_STATUS_CEDOC, StatusContratoCEDOC } from '~/constant';
import moment from 'moment';

const STATUS_COLORS = {
  [StatusContratoCEDOC.Pendente]: '#FFC107',
  [StatusContratoCEDOC.Recebido]: '#17A2B8',
  [StatusContratoCEDOC.Aprovado]: '#28a745',
  [StatusContratoCEDOC.Recusado]: '#DC3545',
};

const ModalCEDOC = ({
  mostrarModal,
  setMostrarModal,
  contrato,
  permissoesCEDOC,
  onAtualizacao,
}) => {
  const [loading, setLoading] = useState(false);
  const [historico, setHistorico] = useState([]);
  const [statusAtual, setStatusAtual] = useState(null);
  const [justificativa, setJustificativa] = useState('');
  const [mostrarCampoJustificativa, setMostrarCampoJustificativa] = useState(false);

  useEffect(function() {
    if (mostrarModal && contrato && contrato.numeroPreVenda) {
      carregarDados();
    }
  }, [mostrarModal, contrato]);

  var carregarDados = function() {
    setLoading(true);
    Promise.all([
      api.buscarHistoricoCEDOC(contrato.numeroPreVenda),
      api.buscarStatusCEDOC(contrato.numeroPreVenda),
    ])
      .then(function(results) {
        setHistorico(results[0] || []);
        setStatusAtual(results[1]);
      })
      .catch(function(error) {
        console.error('Erro ao carregar dados CEDOC:', error);
        toast.error('Erro ao carregar dados do contrato');
      })
      .finally(function() {
        setLoading(false);
      });
  };

  var getStatusInfo = function(statusValue) {
    var status = DESCRICOES_STATUS_CEDOC.find(function(s) {
      return s.value === statusValue;
    });
    return status || { label: 'Desconhecido', cor: '#6c757d' };
  };

  var handleReceber = function() {
    setLoading(true);
    var registrar = statusAtual
      ? api.receberContratoCEDOC(contrato.numeroPreVenda)
      : api.criarRegistroPendenteCEDOC(contrato.numeroPreVenda)
          .then(function() {
            return api.receberContratoCEDOC(contrato.numeroPreVenda);
          });

    registrar
      .then(function() {
        toast.success('Contrato recebido com sucesso!');
        carregarDados();
        if (onAtualizacao) onAtualizacao();
      })
      .catch(function(error) {
        toast.error((error && error.message) || 'Erro ao registrar recebimento');
      })
      .finally(function() {
        setLoading(false);
      });
  };

  var handleAprovar = function() {
    setLoading(true);
    api.aprovarContratoCEDOC(contrato.numeroPreVenda, { Justificativa: justificativa })
      .then(function() {
        toast.success('Contrato aprovado com sucesso!');
        setJustificativa('');
        carregarDados();
        if (onAtualizacao) onAtualizacao();
      })
      .catch(function(error) {
        toast.error((error && error.message) || 'Erro ao aprovar contrato');
      })
      .finally(function() {
        setLoading(false);
      });
  };

  var handleRecusar = function() {
    if (!justificativa.trim()) {
      toast.warning('A justificativa é obrigatória para recusar o contrato');
      return;
    }
    setLoading(true);
    api.recusarContratoCEDOC(contrato.numeroPreVenda, { Justificativa: justificativa })
      .then(function() {
        toast.success('Contrato recusado');
        setJustificativa('');
        setMostrarCampoJustificativa(false);
        carregarDados();
        if (onAtualizacao) onAtualizacao();
      })
      .catch(function(error) {
        toast.error((error && error.message) || 'Erro ao recusar contrato');
      })
      .finally(function() {
        setLoading(false);
      });
  };

  var fecharModal = function() {
    setMostrarModal(false);
    setJustificativa('');
    setMostrarCampoJustificativa(false);
  };

  var podeReceber = function() {
    return (
      permissoesCEDOC && permissoesCEDOC.podeGerenciar &&
      (!statusAtual ||
        statusAtual.status === StatusContratoCEDOC.Pendente ||
        statusAtual.status === StatusContratoCEDOC.Recusado)
    );
  };

  var podeAprovarRecusar = function() {
    return (
      permissoesCEDOC && permissoesCEDOC.podeGerenciar &&
      statusAtual &&
      statusAtual.status === StatusContratoCEDOC.Recebido
    );
  };

  var getStatusColor = function(status) {
    return STATUS_COLORS[status] || '#6c757d';
  };

  var styles = {
    modalBody: {
      maxHeight: '70vh',
      overflowY: 'auto',
      padding: '20px 30px',
    },
    headerInfo: {
      backgroundColor: '#f8f9fa',
      padding: '15px 20px',
      borderRadius: '8px',
      marginBottom: '20px',
    },
    sectionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#333',
      marginBottom: '20px',
      paddingBottom: '10px',
      borderBottom: '1px solid #e0e0e0',
    },
    timeline: {
      position: 'relative',
      padding: '20px 0',
    },
    timelineItem: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '40px',
      position: 'relative',
    },
    dateLabel: {
      position: 'relative',
      minWidth: '200px',
      height: '44px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      fontWeight: '600',
      fontSize: '14px',
      marginRight: '20px',
      clipPath: 'polygon(0 0, calc(100% - 15px) 0, 100% 50%, calc(100% - 15px) 100%, 0 100%)',
      paddingRight: '15px',
    },
    markerColumn: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '40px',
      position: 'relative',
    },
    marker: {
      width: '14px',
      height: '14px',
      borderRadius: '50%',
      border: '3px solid',
      backgroundColor: '#fff',
      zIndex: 2,
      marginTop: '15px',
    },
    timelineLine: {
      position: 'absolute',
      left: '50%',
      top: '0',
      bottom: '0',
      width: '2px',
      backgroundColor: '#e0e0e0',
      transform: 'translateX(-50%)',
      zIndex: 1,
    },
    contentBlock: {
      flex: 1,
      paddingLeft: '15px',
      paddingTop: '5px',
    },
    eventTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#333',
      marginBottom: '4px',
    },
    eventUser: {
      fontSize: '14px',
      color: '#666',
      marginBottom: '8px',
    },
    eventDetail: {
      fontSize: '14px',
      color: '#333',
    },
    actionButtons: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
      marginTop: '20px',
      paddingTop: '20px',
      borderTop: '1px solid #e0e0e0',
    },
    justificativaContainer: {
      marginTop: '15px',
      padding: '15px',
      backgroundColor: '#fff3cd',
      borderRadius: '8px',
    },
    textarea: {
      width: '100%',
      padding: '10px',
      borderRadius: '4px',
      border: '1px solid #ced4da',
      fontSize: '14px',
      resize: 'vertical',
      minHeight: '80px',
    },
    charCount: {
      fontSize: '12px',
      color: '#666',
      textAlign: 'right',
      marginTop: '5px',
    },
  };

  return (
    <Modal show={mostrarModal} onHide={fecharModal} size="lg" backdrop="static">
      <Modal.Header closeButton style={{ borderBottom: '1px solid #e0e0e0' }}>
        <Modal.Title style={{ fontSize: '18px', fontWeight: '600' }}>
          <FaInbox style={{ marginRight: '10px', color: '#17A2B8' }} />
          Workflow CEDOC - Pre-venda #{contrato && contrato.numeroPreVenda}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={styles.modalBody}>
        {loading && (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <Spinner animation="border" variant="primary" />
            <p style={{ marginTop: '15px', color: '#666' }}>Carregando...</p>
          </div>
        )}

        {!loading && (
          <>
            <div style={styles.headerInfo}>
              <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <div style={{ marginBottom: '10px' }}>
                  <small style={{ color: '#666', display: 'block' }}>Cliente:</small>
                  <span style={{ fontWeight: '500' }}>{(contrato && contrato.nomeCliente) || '-'}</span>
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <small style={{ color: '#666', display: 'block' }}>Empreendimento:</small>
                  <span style={{ fontWeight: '500' }}>{(contrato && contrato.nomeEmpreendimento) || '-'}</span>
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <small style={{ color: '#666', display: 'block' }}>Status Atual:</small>
                  {statusAtual ? (
                    <span
                      style={{
                        display: 'inline-block',
                        padding: '4px 12px',
                        borderRadius: '4px',
                        backgroundColor: getStatusInfo(statusAtual.status).cor,
                        color: '#fff',
                        fontWeight: '600',
                        fontSize: '13px',
                      }}
                    >
                      {getStatusInfo(statusAtual.status).label}
                    </span>
                  ) : (
                    <span style={{ color: '#999' }}>Sem registro</span>
                  )}
                </div>
              </div>
            </div>

            {permissoesCEDOC && permissoesCEDOC.podeGerenciar && (
              <div style={styles.actionButtons}>
                {podeReceber() && (
                  <Button
                    variant="info"
                    onClick={handleReceber}
                    disabled={loading}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                  >
                    <FaInbox />
                    Registrar Recebimento
                  </Button>
                )}
                {podeAprovarRecusar() && (
                  <>
                    <Button
                      variant="success"
                      onClick={handleAprovar}
                      disabled={loading}
                      style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                    >
                      <FaCheck />
                      Aprovar
                    </Button>
                    <Button
                      variant="danger"
                      onClick={function() { setMostrarCampoJustificativa(true); }}
                      disabled={loading}
                      style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                    >
                      <FaTimes />
                      Recusar
                    </Button>
                  </>
                )}
              </div>
            )}

            {mostrarCampoJustificativa && (
              <div style={styles.justificativaContainer}>
                <label style={{ fontWeight: '600', marginBottom: '8px', display: 'block' }}>
                  Justificativa para recusa *
                </label>
                <textarea
                  style={styles.textarea}
                  value={justificativa}
                  onChange={function(e) { setJustificativa(e.target.value); }}
                  placeholder="Informe o motivo da recusa..."
                  maxLength={300}
                />
                <div style={styles.charCount}>
                  {justificativa.length}/300 caracteres
                </div>
                <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                  <Button
                    variant="danger"
                    onClick={handleRecusar}
                    disabled={loading || !justificativa.trim()}
                    size="sm"
                  >
                    Confirmar Recusa
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={function() {
                      setMostrarCampoJustificativa(false);
                      setJustificativa('');
                    }}
                    size="sm"
                  >
                    Cancelar
                  </Button>
                </div>
              </div>
            )}

            <div style={{ marginTop: '30px' }}>
              <div style={styles.sectionTitle}>Histórico</div>
              {historico.length > 0 ? (
                <div style={styles.timeline}>
                  {historico.map(function(item, index) {
                    var statusInfo = getStatusInfo(item.status);
                    var color = getStatusColor(item.status);
                    var isLast = index === historico.length - 1;

                    return (
                      <div key={item.codigo || index} style={styles.timelineItem}>
                        <div
                          style={{
                            ...styles.dateLabel,
                            backgroundColor: color,
                          }}
                        >
                          {moment(item.data).format('DD/MM/YYYY HH:mm:ss')}
                        </div>

                        <div style={styles.markerColumn}>
                          <div
                            style={{
                              ...styles.marker,
                              borderColor: color,
                            }}
                          />
                          {!isLast && (
                            <div
                              style={{
                                ...styles.timelineLine,
                                top: '29px',
                                bottom: '-40px',
                              }}
                            />
                          )}
                        </div>

                        <div style={styles.contentBlock}>
                          <div style={styles.eventTitle}>{statusInfo.label}</div>
                          <div style={styles.eventUser}>{item.nome_usuario || 'Usuário não identificado'}</div>
                          {item.justificativa && (
                            <div style={styles.eventDetail}>
                              <strong>Justificativa:</strong> {item.justificativa}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p style={{ color: '#999', fontStyle: 'italic' }}>Nenhum registro no histórico</p>
              )}
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer style={{ borderTop: '1px solid #e0e0e0' }}>
        <Button
          variant="warning"
          onClick={fecharModal}
          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          <FaWindowClose />
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCEDOC;
